module.exports = __webpack_public_path__ + "img/feature-ico-2.132f9e8b.svg";